<template>
    <div>
        <NavBar />
         <HeroPage />
        <AboutUs />
        <WhyPage />
        <CallToAction />
        <FooterPage />
          </div>
</template>

<script>
import HeroPage from '../components/HeroPage.vue'
import NavBar from '../components/NavBar.vue'
import AboutUs from '../components/AboutUs.vue'
import WhyPage from '../components/WhyPage.vue'
import CallToAction from '../components/CallToAction.vue'
import FooterPage from '../components/FooterPage.vue'

export default {
  name: 'HomePage',
  components: {
    HeroPage,
    NavBar, AboutUs, WhyPage, CallToAction, FooterPage
  }
}
</script>

